var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          ref: "tableStationSale" + _vm.sheetType,
          attrs: {
            data: _vm.groupData,
            "highlight-current-row": "",
            height: "700",
            "summary-method": _vm.getSummaries,
            "show-summary": "",
            "cell-style": _vm.cellStyle,
            "header-cell-style": { "text-align": "center" },
            border: ""
          },
          on: { "filter-change": _vm.filterChange }
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              label: _vm.selectedArea,
              align: "center",
              "column-key": "area",
              filters: _vm.filterMapping,
              "filter-multiple": false,
              "filter-placement": "right",
              "filter-method": _vm.filterHandler
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.sellerName(scope.row.sellerId)) + " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "circleAmount92",
              label:
                _vm.timestamp2beforeyeardatestring(_vm.end / 1000, "YY年", 1) +
                "平均日销量",
              align: "center"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.sellerMonthAvg(
                            _vm.sheetType,
                            scope.row.sellerId,
                            _vm.timestamp2beforeyeardatestring(
                              _vm.end / 1000,
                              "YYYY",
                              1
                            )
                          )
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "circleAmount95",
              label:
                _vm.timestamp2beforemonthdatestring(
                  _vm.end / 1000,
                  "YY年MM月",
                  1
                ) + "日均",
              align: "center"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.sellerMonthAvg(
                            _vm.sheetType,
                            scope.row.sellerId,
                            _vm.timestamp2beforemonthdatestring(
                              _vm.end / 1000,
                              "YYYYMM",
                              1
                            )
                          )
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c(
            "el-table-column",
            {
              attrs: {
                label:
                  "月份：" +
                  _vm.timestamp2datestring(_vm.end / 1000, "YY年MM月"),
                align: "center"
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.timestamp2datestring(_vm.end / 1000, "DD日"),
                  align: "center",
                  prop: _vm.totalCounterDisplayName
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "累计日均",
                  align: "center",
                  prop: _vm.totalCounterAvgDisplayName
                }
              })
            ],
            1
          ),
          _c("el-table-column", {
            attrs: {
              prop: "circleAmount0",
              label: "与上月对比",
              align: "center"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "mini",
                          type:
                            scope.row[_vm.totalCounterAvgDisplayName] >
                            _vm.sellerMonthAvg(
                              _vm.sheetType,
                              scope.row.sellerId,
                              _vm.timestamp2beforemonthdatestring(
                                _vm.end / 1000,
                                "YYYYMM",
                                1
                              )
                            )
                              ? "success"
                              : "danger"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.npPercent(
                                scope.row[_vm.totalCounterAvgDisplayName],
                                _vm.sellerMonthAvg(
                                  _vm.sheetType,
                                  scope.row.sellerId,
                                  _vm.timestamp2beforemonthdatestring(
                                    _vm.end / 1000,
                                    "YYYYMM",
                                    1
                                  )
                                )
                              ) + "%"
                            )
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }